import React, { VFC } from 'react';

import { ButtonSizes } from '@rbilabs/components-library';
import { useIntl } from 'react-intl';

import { ActionButtonVariants } from 'components/action-button';
import { useResetConfirmDialog } from 'hooks/menu/use-reset-confirm-dialog';

import { StyledResetButton } from './product-customization-reset.styled';
import { IProductCustomizationResetProps } from './types';

export const ProductCustomizationReset: VFC<IProductCustomizationResetProps> = ({
  onReset,
  showButton,
}) => {
  const { formatMessage } = useIntl();

  const { openConfirmationDialog, ResetConfirmDialog } = useResetConfirmDialog(() => onReset());

  return (
    <>
      {showButton && (
        <StyledResetButton
          variant={ActionButtonVariants.OUTLINE}
          size={ButtonSizes.SMALL}
          onClick={openConfirmationDialog}
        >
          {formatMessage({ id: 'reset' })}
        </StyledResetButton>
      )}
      {ResetConfirmDialog}
    </>
  );
};

export default ProductCustomizationReset;
